import { useState } from "react"
import { useForm } from '@laramie/ui';
import { UNIDAD_VALORES } from ".."
import {TIPS} from "../../../consts/tips";

import { FormError, FormLabel, InputLista, InputNumber, Modal } from "../../../components/common"
import { useFormErrors } from "../../../components/hooks/useFormErrors"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const TipoMultaModal = ({ mode, item, onConfirm, onCancel }) => {
    const [formValues, formHandle] = useForm(item)
    const [pendingChange, setPendingChange] = useState(false)

    const onInputChange = (...args) => {
        setPendingChange(true)
        formHandle(...args)
    }

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (formValues.idUnidadValor <= 0) errors.idUnidadValor = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.valorDesde <= 0) errors.valorDesde = 'Ingresá un número mayor a cero'
        if (formValues.valorHasta <= 0) errors.valorHasta = 'Ingresá un número mayor a cero'
        else if (formValues.valorHasta < formValues.valorDesde) errors.valorHasta = 'Menor al valor desde'

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (mode === 'view') return errors

        if (formValues.orden < 0) errors.orden = 'No puede ser negativo'

        return errors
    }

    const onClickGuardar = () => {
        if (!validate()) return

        if (formValues.idUnidadValor === UNIDAD_VALORES.UF) {
            onConfirm({
                ...formValues,
                valorDesde: Math.round(formValues.valorDesde),
                valorHasta: Math.round(formValues.valorHasta),
            })
        }
        else onConfirm(formValues)
    }

    return (
        <Modal
            onEscape={onCancel}
            show
            title="Tipo de multa"
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            body={(
                <div className="row form-basic">
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            name="codigo"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={onInputChange}
                            disabled={mode === 'view'}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-9">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            name="nombre"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={onInputChange}
                            disabled={mode === 'view'}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
                    <div className="col-12 col-md-3">
                        <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                        <InputLista
                            lista="TipoTributo"
                            name="idTipoTributo"
                            placeholder=""
                            className="form-control"
                            value={formValues.idTipoTributo}
                            onChange={onInputChange}
                            disabled={mode === 'view'}
                        />
                        <FormError />
                    </div>
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="idUnidadValor" required>Unidad de valor</FormLabel>
                        <InputLista
                            lista="UnidadValor"
                            name="idUnidadValor"
                            placeholder=""
                            className={`form-control ${errorOf('idUnidadValor') ? 'is-invalid' : ''}`}
                            value={formValues.idUnidadValor}
                            onChange={onInputChange}
                            disabled={mode === 'view'}
                        />
                        <FormError message={errorOf('idUnidadValor')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <label htmlFor="orden" className="form-label">Orden</label>
                        <InputNumber
                            name="orden"
                            className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                            precision={0}
                            value={formValues.orden}
                            onChange={onInputChange}
                            disabled={mode === 'view'}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="valorDesde" required>Valor desde</FormLabel>
                        <InputNumber
                            name="valorDesde"
                            className={`form-control ${errorOf('valorDesde') ? 'is-invalid' : ''}`}
                            precision={formValues.idUnidadValor === UNIDAD_VALORES.UF ? 0 : 2}
                            value={formValues.valorDesde}
                            onChange={onInputChange}
                            disabled={mode === 'view'}
                        />
                        <FormError message={errorOf('valorDesde')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="valorHasta" required>Valor hasta</FormLabel>
                        <InputNumber
                            name="valorHasta"
                            className={`form-control ${errorOf('valorHasta') ? 'is-invalid' : ''}`}
                            precision={formValues.idUnidadValor === UNIDAD_VALORES.UF ? 0 : 2}
                            value={formValues.valorHasta}
                            onChange={onInputChange}
                            disabled={mode === 'view'}
                        />
                        <FormError message={errorOf('valorHasta')} />
                    </div>
                </div>
            )}
            footer={<>
                    {mode !== 'view' && ( <>
                        <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onCancel}>Cancelar</button>
                        <button
                            className={"btn btn-primary"}
                            data-dismiss="modal"
                            onClick={onClickGuardar}
                            disabled={mode === 'view'}
                        >Aceptar</button>
                    </> )}
                    {mode == 'view' && ( 
                        <div className="width-100p f-align">
                            <button className="btn back-button" data-dismiss="modal" onClick={onCancel}>Volver</button>
                        </div>
                    )}
                    
            </>}
        />
    )
}

export default TipoMultaModal
